import { EUROPEAN_SOCCER_LEAGUES_KEYS, WebSportItem } from "src/constants";

export const isEuropeanSoccerLeague = (sportObj: WebSportItem): boolean => {
  if (EUROPEAN_SOCCER_LEAGUES_KEYS.includes(sportObj.key)) {
    return true;
  }
  return false;
};
